import { render, staticRenderFns } from "./AccordionDisplay.vue?vue&type=template&id=b8dbbf16"
import script from "./AccordionDisplay.vue?vue&type=script&lang=js"
export * from "./AccordionDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports